import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modals/modal/modal.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CanvasControlComponent } from 'src/app/features/bizzmine/form/components/controls/canvas-control/canvas-control.component';
import { DocumentEventsService } from 'src/app/shared/services/document-events/document-events.service';
import { EditorModule } from '@progress/kendo-angular-editor';

@Component({
  selector: 'bizz-signature-dialog',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    CanvasControlComponent,
    EditorModule
  ],
  templateUrl: './signature-dialog.component.html',
  styleUrl: './signature-dialog.component.scss'
})
export class SignatureDialogComponent implements AfterViewInit {
  public editMode = false;
  public canvasOptions: {
    CanUseToolbar?: boolean,
    CanDraw: boolean,
    CanEditImage: boolean,
    IsReadOnly: boolean,
    CanvasHeight: number,
    FullWidth?: boolean,
    DefaultStrokeWidth: number,
  } | undefined = undefined;

  @ViewChild('canvasPad') public canvasPad: CanvasControlComponent | null = null;

  public constructor(public dialogRef: DialogRef,
                     @Inject(DIALOG_DATA) public data: {
                       signature: string | undefined,
                       userName: string | undefined,
                       sessionName: string | undefined,
                       readOnly: boolean
                     }, public documentEventsService: DocumentEventsService,
                     private elementRef: ElementRef) {
    if (data?.signature != undefined) {
      this.editMode = true;
    }
    this.dialogRef.disableClose = true;
  }

  public clear(): void {
    this.data.signature = undefined;
    if (this.canvasPad)
      this.canvasPad.setBlankCanvasImage();
    this.editMode = false;
  }

  public ngAfterViewInit(): void {
    const width = this.elementRef.nativeElement.offsetWidth;
    this.canvasOptions = {
      CanUseToolbar: true,
      CanDraw: true,
      CanEditImage: false,
      IsReadOnly: false,
      FullWidth: true,
      CanvasHeight: width / 3,
      DefaultStrokeWidth: 3
    };
  }

  public save(): void {
    this.dialogRef.close({ data: this.data?.signature });
  }
}
